module.exports = __webpack_public_path__ + "static/media/postgres.e36edc11.png";